import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { onAuthDispatch as dispatchSelector } from 'reduxModules/auth/dispatchers'
import RegisterBox from '../../generic/RegisterBox'
import '../styles.css'
import './styles.css'

export class SignUp extends Component {
  constructor(props) {
    super(props)
    props.hideGlobalNav()
  }

  componentWillUnmount() {
    this.props.showGlobalNav()
  }

  render() {
    return (
      <div id="SignUp" className="auth-page">
        <div>
          <div className="info">
            <div className="logo">
              <Link to="/">
                <img src="/global/assets/images/logo/logo-big.png" alt="Stan Winston School Of Character Arts" />
              </Link>
            </div>
            <div className="title-container">
              <h1>welcome to Stan Winston School Of Character Arts</h1>
            </div>
            <ul>
              <li>Access to behind the scenes monster making magic</li>
              <li>Exclusive images and videos of your favorites movie creatures</li>
              <li>Free Access to mini-tutorials and web exclusives</li>
              <li>Optional free weekly newsletter</li>
              <li>Be the first to subscribe to our weekly and monthly contests</li>
            </ul>
          </div>
          <div className="logo-mobile">
            <Link to="/">
              <img src="/global/assets/images/logo/logo-big.png" alt="Stan Winston School Of Character Arts" />
            </Link>
          </div>
          <RegisterBox {...this.props} autoFocus />
        </div>
      </div>
    )
  }
}

SignUp.propTypes = {
  showGlobalNav: PropTypes.func.isRequired,
  hideGlobalNav: PropTypes.func.isRequired
}

export default connect(
  null,
  dispatchSelector
)(SignUp)
